/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Alert API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useMutation } from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  AlertGroupCountRequestBody,
  ApiResponseAlertCountItem,
  ApiResponseAlertRuleSummaryItem,
  PostV11AlertsAlertGroupRulesFilteredParams,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary 알람 그룹별 개수 조회 (platformTypes/targetId/dataId/fieldName 기준, 대시보드 비종속)
 */
export const postV11AlertsAlertGroupCountFiltered = (
  alertGroupCountRequestBody: MaybeRef<AlertGroupCountRequestBody>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  alertGroupCountRequestBody = unref(alertGroupCountRequestBody);

  return customAxiosInstance<ApiResponseAlertCountItem>(
    {
      url: `/api/v11/alerts/alert-group/count/filtered`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: alertGroupCountRequestBody,
      signal,
    },
    options,
  );
};

export const getPostV11AlertsAlertGroupCountFilteredMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV11AlertsAlertGroupCountFiltered>>,
    TError,
    { data: BodyType<AlertGroupCountRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV11AlertsAlertGroupCountFiltered>>,
  TError,
  { data: BodyType<AlertGroupCountRequestBody> },
  TContext
> => {
  const mutationKey = ['postV11AlertsAlertGroupCountFiltered'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV11AlertsAlertGroupCountFiltered>>,
    { data: BodyType<AlertGroupCountRequestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postV11AlertsAlertGroupCountFiltered(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV11AlertsAlertGroupCountFilteredMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV11AlertsAlertGroupCountFiltered>>
>;
export type PostV11AlertsAlertGroupCountFilteredMutationBody = BodyType<AlertGroupCountRequestBody>;
export type PostV11AlertsAlertGroupCountFilteredMutationError = ErrorType<unknown>;

/**
 * @summary 알람 그룹별 개수 조회 (platformTypes/targetId/dataId/fieldName 기준, 대시보드 비종속)
 */
export const usePostV11AlertsAlertGroupCountFiltered = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV11AlertsAlertGroupCountFiltered>>,
      TError,
      { data: BodyType<AlertGroupCountRequestBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV11AlertsAlertGroupCountFiltered>>,
  TError,
  { data: BodyType<AlertGroupCountRequestBody> },
  TContext
> => {
  const mutationOptions = getPostV11AlertsAlertGroupCountFilteredMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 발생한 알람 룰 정보 (platformTypes/targetId/dataId/fieldName 기준, 대시보드 비종속)
 */
export const postV11AlertsAlertGroupRulesFiltered = (
  alertGroupCountRequestBody: MaybeRef<AlertGroupCountRequestBody>,
  params?: MaybeRef<PostV11AlertsAlertGroupRulesFilteredParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  alertGroupCountRequestBody = unref(alertGroupCountRequestBody);
  params = unref(params);

  return customAxiosInstance<ApiResponseAlertRuleSummaryItem>(
    {
      url: `/api/v11/alerts/alert-group/rules/filtered`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: alertGroupCountRequestBody,
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV11AlertsAlertGroupRulesFilteredMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV11AlertsAlertGroupRulesFiltered>>,
    TError,
    {
      data: BodyType<AlertGroupCountRequestBody>;
      params?: PostV11AlertsAlertGroupRulesFilteredParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV11AlertsAlertGroupRulesFiltered>>,
  TError,
  {
    data: BodyType<AlertGroupCountRequestBody>;
    params?: PostV11AlertsAlertGroupRulesFilteredParams;
  },
  TContext
> => {
  const mutationKey = ['postV11AlertsAlertGroupRulesFiltered'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV11AlertsAlertGroupRulesFiltered>>,
    {
      data: BodyType<AlertGroupCountRequestBody>;
      params?: PostV11AlertsAlertGroupRulesFilteredParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return postV11AlertsAlertGroupRulesFiltered(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV11AlertsAlertGroupRulesFilteredMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV11AlertsAlertGroupRulesFiltered>>
>;
export type PostV11AlertsAlertGroupRulesFilteredMutationBody = BodyType<AlertGroupCountRequestBody>;
export type PostV11AlertsAlertGroupRulesFilteredMutationError = ErrorType<unknown>;

/**
 * @summary 발생한 알람 룰 정보 (platformTypes/targetId/dataId/fieldName 기준, 대시보드 비종속)
 */
export const usePostV11AlertsAlertGroupRulesFiltered = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV11AlertsAlertGroupRulesFiltered>>,
      TError,
      {
        data: BodyType<AlertGroupCountRequestBody>;
        params?: PostV11AlertsAlertGroupRulesFilteredParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV11AlertsAlertGroupRulesFiltered>>,
  TError,
  {
    data: BodyType<AlertGroupCountRequestBody>;
    params?: PostV11AlertsAlertGroupRulesFilteredParams;
  },
  TContext
> => {
  const mutationOptions = getPostV11AlertsAlertGroupRulesFilteredMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
